import React, { useContext, useState } from 'react';
import { Box as Wrapper, Icon, Space, Text } from '@tonic-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import HeroBanner from './hero-banner';
import {
  CloudVideoContent,
  CustomersCarousel,
  SecurityConcernsSection,
  TileCarousel,
} from '../../components/public-landing-page';
import NotificationBanner from '../../components/notification-banner/notification-banner';
import { AuthContext } from '../../context/AuthContext';
import { useMarketplaceDetails } from '../../hooks/useMarketplaceDetails';
import { copyToClipboard, isMaintenanceModeEnabled } from '../../utils/helpers';
import { ExternalLink } from '../../components/external-link';

const PublicLanding = () => {
  const { eventDistributor, hasRequestErrors } = useContext(AuthContext);
  const [copySuccess, setCopySuccess] = useState(false);
  const [showBanner, setShowBanner] = useState({
    confirmationNotice: false,
    message: '',
  });
  const { t } = useTranslation();
  const { marketplaceProvider = '', marketplaceToken = '' } = useMarketplaceDetails();
  const [sourceAccountIntegrationConfig] = useState(
    JSON.parse(localStorage.getItem('C1C_SourceAccountIntegrationRequest') || 'null')
  );
  const updateBannerBannerState = (updatedState) =>
    setShowBanner((prevState) => ({ ...prevState, ...updatedState }));

  return (
    <>
      {isMaintenanceModeEnabled && (
        <NotificationBanner
          name="maintenance-notice"
          severity="warning"
          showCloseButton={false}
          shouldOpen={true}
          htmlElement={
            <Text as="p" m="0" display="inline-block">
              <Trans i18nKey={`publicLandingPage.maintenanceNotice.${DEPLOYMENT_TARGET}.message`} />
              <ExternalLink
                href={t(`publicLandingPage.maintenanceNotice.${DEPLOYMENT_TARGET}.link`)}
                textDecoration="none"
                showIcon={false}
              >
                {`${
                  DEPLOYMENT_TARGET === 'stage'
                    ? t(`publicLandingPage.maintenanceNotice.${DEPLOYMENT_TARGET}.link`)
                    : `${window.location.origin}${t(
                        `publicLandingPage.maintenanceNotice.${DEPLOYMENT_TARGET}.link`
                      )}`
                }`}
              </ExternalLink>
              <Space width="1x" />
              {DEPLOYMENT_TARGET === 'stage' &&
                t(`publicLandingPage.maintenanceNotice.${DEPLOYMENT_TARGET}.contact`)}
            </Text>
          }
        />
      )}
      {marketplaceToken !== '' ? (
        <NotificationBanner
          name="marketplace-info"
          severity="info"
          backgroundColor="yellow:50"
          shouldOpen={true}
          showCloseButton={true}
          width="100%"
          bannerText={`loginView.marketplaceBannerText.${marketplaceProvider}`}
          bannerButtonTxt={
            copySuccess
              ? 'loginView.copyToClipboardSuccessMsg'
              : 'loginView.marketPlaceBannerBtnText'
          }
          bannerButtonIcon={
            copySuccess ? <Icon icon="check-bold" color="green:50" marginRight={10}></Icon> : <></>
          }
          clickHandler={async () => setCopySuccess(await copyToClipboard(window.location.href))}
        />
      ) : null}
      {sourceAccountIntegrationConfig && (
        <NotificationBanner
          name="sourceaccount-info"
          severity="info"
          backgroundColor="yellow:50"
          shouldOpen={true}
          showCloseButton={true}
          width="100%"
          bannerText={`loginView.sourceAccountBannerText.${sourceAccountIntegrationConfig?.sourceAccountIntegrationProvider}`}
        />
      )}
      {hasRequestErrors?.error && (
        <NotificationBanner
          name="error-info"
          severity="error"
          shouldOpen={true}
          showCloseButton={true}
          width="100%"
          bannerText={`errorMessaging.title`}
        />
      )}
      {showBanner.confirmationNotice && (
        <NotificationBanner
          name="confirmation-notice"
          severity="warning"
          showCloseButton={true}
          shouldOpen={showBanner.confirmationNotice}
          bannerText="resendConfirmation.bannerTitle"
          bannerButtonTxt="resendConfirmation.bannerBtn"
          clickHandler={() =>
            eventDistributor.dispatch({
              type: 'NAVIGATE_APP',
              appName: 'resend-confirmation',
            })
          }
        />
      )}
      <HeroBanner showAlertBanner={updateBannerBannerState} />
      <SecurityConcernsSection />
      <CustomersCarousel />
      <Wrapper minWidth={900} maxWidth={1285} margin="0 auto 140px">
        <CloudVideoContent />
        <TileCarousel />
      </Wrapper>
    </>
  );
};

export default PublicLanding;
